export { default as DEFAULT_PROFILE_PICTURE } from '@/assets/imgs/default-avatar.jpg';

export { default as PATHS } from './paths';
export { default as PERMISSIONS } from './permissionCodes';

export { default as ERROR_CODES } from './errorCodes';

export const STORE_KEY = process.env.VUE_APP_STORE_KEY;
export const PASSWORD_MIN_LENGTH = 6;
export const MILLION = 1000 * 1000;

export const FLASH_TYPES = {
  INFO: 'info',
  ERROR: 'error'
};

export const ORDER_STEP = {
  UNCLAIMED: 'Unclaimed',
  CONTACT: 'Contact',
  PENDING: 'Pending',
  APPOINTMENT: 'Appointment',
  QUOTED: 'Quoted',
  CONTRACT: 'Contract',
  COLD_LEAD: 'Cold lead',
  WARM_LEAD: 'Warm lead'
};

export const ORDER_SOURCE = {
  CHAT: 'Chat',
  FANPAGE: 'Fanpage',
  HOSTLINE: 'Hotline',
  ONLINE: 'Online',
  OFFILINE: 'Offline',
  WALK_IN: 'Walk-in',
  REFERRAL: 'Referral',
  OLD_CUSTOMER: 'Old Customer',
  AFFILIATE: 'Affiliate'
};

export const ORDER_STATUS = {
  IN_PROGRESS: 'In Progress',
  OPEN: 'Open',
  FAILED: 'Failed',
  INVALID: 'Invalid',
  SUCCESS: 'Success'
};

export const ORDER_STAGE = {
  NOT_ELIGIBLE: { val: 'Not eligible', status: 'Failed' },
  NOT_IN_SERVICE_REGION: { val: 'Not in service region', status: 'Failed' },
  NO_PICK_UP: { val: 'No Pick-up', status: 'Failed' },
  WINDOW_SHOPPING: { val: 'Window shopping', status: 'Invalid' },
  UNABLE_TO_APPRAISE_LIQUIDATED: { val: 'Unable to Appraise/Liquidated', status: 'Failed' },
  DUPLICATE: { val: 'Duplicate', status: 'Invalid' },
  RATE_DISAGREEMENT: { val: 'Rate Disagreement', status: 'Failed' },
  NO_SHOW: { val: 'No Show', status: 'Failed' },
  MONEY_FROM_DIFFERENT_CHANNEL: { val: 'Money from different channel', status: 'Failed' },
  TERMS_DISAGREEMENT: { val: 'Terms Disagreement', status: 'Failed' },
  SPAM: { val: 'Spam', status: 'Invalid' },
  CALL_AGAIN_LATER: { val: 'Call Again Later', status: 'In Progress' },
  WAITING_FOR_MORE_INFO: { val: 'Waiting for more info', status: 'In Progress' },
  CONSIDERING: { val: 'Considering', status: 'In Progress' },
  ORDER_CLAIMED: { val: 'Order Claimed', status: 'In Progress' },
  WAITING_FOR_RATE: { val: 'Waiting for Rate', status: 'In Progress' },
  APPOINTMENT_1: { val: 'Appointment #1', status: 'In Progress' },
  APPOINTMENT_2: { val: 'Appointment #2', status: 'In Progress' },
  APPOINTMENT_3: { val: 'Appointment #3', status: 'In Progress' },
  APPOINTMENT_4: { val: 'Appointment #4', status: 'In Progress' },
  UNCLAIMED: { val: 'Unclaimed', status: 'In Progress' },
  FRAUD: { val: 'Fraud', status: 'Failed' },
  VERY_ANNOYED: { val: 'Very annoyed', status: 'Failed' },
  ANNOYED: { val: 'Annoyed', status: 'Failed' },
  NOT_INTERESTED: { val: 'Not interested', status: 'Failed' },
  NOT_CALLED_YET: { val: 'Not called yet', status: 'In Progress' },
  WRONG_NUMBER: { val: 'Wrong number', status: 'Invalid' },
  UNABLE_TO_CONTACT: { val: 'Unable to contact', status: 'Invalid' },
  NOT_PICK_UP: { val: 'Not pick-up', status: 'In Progress' },
  INTERESTED: { val: 'Interested', status: 'In Progress' },
  VERY_INTERESTED: { val: 'Very interested', status: 'In Progress' },
  DEMAND_IN_THE_FUTURE: { val: 'Demand in the future', status: 'In Progress' },
  CLOSE_SALE: { val: 'Close sale', status: 'In Progress' },
  CHANGE_NUMBER: { val: 'Change number', status: 'Invalid' },
  ACTIVE_CONTRACT: { val: 'Active Contract', status: 'Success' }
};

export const CLIENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inacvite',
  DORMANT: 'dormant',
  NO_CONTRACT: 'no contract',
  IN_CAMPAIGN: 'in campaign',
  BLACKLIST_OR_LOST: 'blacklist/lost'
};

export const CLIENT_GENDER = {
  MALE: 'male',
  FEMALE: 'female'
};

export const FLASH_TIMEOUT = 5000;

export const MIN_DATE = '2015-01-01';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';
export const DURATION_FORMAT = 'HH:mm:ss.SSS';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DISPLAY_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

export const MODAL_NAMES = {
  SESSION_EXPIRED: 'session-expired',
  DIAL_PAD: 'dial-pad',
  PAYMENT_REMINDER_CLIENT_DETAILS: 'payment-reminder-client-details',
  CONFIRM: 'confirm',
  EDIT_ORDER: 'edit-order',
  EDIT_CLIENT: 'edit-client',
  ORDER_NOTE: 'order-note',
  EDIT_ASSET: 'edit-asset'
};

export const CALL_DIRECTIONS = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
};

export const CALL_STATUSES = {
  CONNECTING: 'CONNECTING',
  RINGING: 'RINGING',
  HAVING_CALL: 'HAVING_CALL',
  PICKING_UP: 'PICKING_UP',
  TALKING: 'TALKING',
  IDLE: 'IDLE'
};

export const TRANSACTION_TYPES = {
  CASH: 'CASH',
  BANK: 'BANK'
};

export const TRANSACTION_STATUSES = {
  REGISTERED: 'REGISTERED',
  RETRACTED: 'RETRACTED'
};

export const FEE_TYPES = {
  OVERDUE: 'OVERDUE',
  LIQUIDIZATION: 'LIQUIDIZATION',
  FAILED_COMMITMENT: 'FAILED_COMMITMENT',
  STORAGE: 'STORAGE'
};

export const FEE_STATUSES = {
  REGISTERED: 'REGISTERED',
  RETRACTED: 'RETRACTED'
};

export const TRANSACTION_ACTIONS = {
  REPAY: 'REPAY',
  RENEW: 'RENEW',
  VOID: 'VOID',
  WAIVE: 'WAIVE'
};

export const CALL_LOG_STATUSES = {
  ANSWERED: 'ANSWERED',
  MISSED: 'MISSED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED'
};

export const CALL_REFS = {
  ORDER: 'ORDER',
  CLIENT: 'CLIENT'
};

export const CASH_LOG_STATUSES = {
  PENDING: 'PENDING',
  REGISTERED: 'REGISTERED',
  RETRACTED: 'RETRACTED'
};

export const CASH_LOG_TYPES = {
  CASH: 'CASH',
  BANK: 'BANK'
};

export const BIG_CLIENT = 'BIG_CLIENT';
export const OVERDUE_GROUP = 'OVERDUE_GROUP';

// for api v2
export const GENDERS = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
};

export const INTEREST_TYPE = {
  ADVANCE: 'ADVANCE',
  ARREARS: 'ARREARS'
};

export const CONTRACT_STATUSES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DISBURSED: 'DISBURSED',
  REPAID: 'REPAID',
  RENEWED: 'RENEWED',
  OVERDUE: 'OVERDUE',
  REJECTED: 'REJECTED'
};

export const ASSET_STATUSES = {
  PENDING: 'PENDING',
  ACQUIRED: 'ACQUIRED',
  IN_STORAGE: 'IN_STORAGE',
  WAITING_TO_LIQUIDIZE: 'WAITING_TO_LIQUIDIZE',
  LIQUIDIZED: 'LIQUIDIZED',
  RELEASED: 'RELEASED'
};

export default {};
